<template>
  <div class="box-container" style="width: 100%">
    <v-row v-if="!error_message" align="center" class="row-header" :class="isOnMobile ? 'ma-2 pa-0' : 'ma-2 pa-0'" :justify="isOnMobile ? 'center' : 'start'">
      <t-button class="ma-2 my-4 pa-0" btnIcon="mdi-email-open" :btnDisabled="activeEmail == null || emails[activeEmail].seen" :style="isOnMobile ? 'width: 130px' : ''" :btnText="isOnMobile ? s_Read : s_MarkRead" @click.native="markAsRead(activeEmail)" />
      <t-button class="ma-2 my-4 pa-0" btnIcon="mdi-email-mark-as-unread" :btnDisabled="activeEmail == null || !emails[activeEmail].seen" :style="isOnMobile ? 'width: 140px' : ''" :btnText="isOnMobile ? s_NotRead : s_MarkNotRead" @click.native="markAsUnread(activeEmail)" />
      <div class="ma-2 my-4 pa-0" :style="isOnMobile ? 'width: 130px' : 'width: 200px'">
        <v-text-field v-model="search" class="ma-0 pa-0" :label="s_FilterBySubject" hide-details=""></v-text-field>
      </div>
      <div class="ma-2 my-4 pa-0" :style="isOnMobile ? 'width: 140px' : 'width: 200px'">
        <v-select v-model="filterType" :items="emailTypes" clearable :label="s_FilterByType" return-object hide-details dense :item-color="isInDarkMode ? '#FFFFFF' : ''">
          <template slot="item" slot-scope="data">
            <span class="pl-2" :style="`margin-bottom: 3px; border-left: 4px solid ${data.item.Color}`">{{ data.item.text }}</span>
          </template>
        </v-select>
      </div>
    </v-row>

    <v-row v-if="isLoading" align="center" justify="center" class="row-header ma-0 pa-0">
      <v-progress-linear :indeterminate="true"></v-progress-linear>
      <v-alert class="subtitle-2" :value="true" color="default">{{ s_DataProcessingPleaseWait }}</v-alert>
    </v-row>
    <v-row v-else-if="error_message" align="center" justify="center" class="ma-0 pa-0">
      <v-alert justify="center" align="center" :class="loaded ? '' : 'subtitle-2'" :value="true" color="default" :icon="loaded ? 'mdi-emoticon-sad' : ' '">{{ error_message }}</v-alert>
    </v-row>

    <div v-if="!error_message" flat class="pa-2 row-content" :style="isInDarkMode ? 'background: #000000' : ''">
      <v-row v-if="filterEmails.length == 0" class="ma-2 pa-2" justify="center" align="center">
        <span v-if="emails.length == 0">{{ s_NoMessagesReceived }}</span>
        <span v-else>{{ s_NoMessagesFound }}</span>
      </v-row>
      <v-expansion-panels inset v-model="activeEmail">
        <v-expansion-panel v-for="(email, i) in filterEmails" :key="i" :style="`margin-bottom: 3px; border-left: 4px solid ${getColorByRank(email.cmessage.rank)}`">
          <v-expansion-panel-header disable-icon-rotate>
            <v-row align="center">
              <!-- <v-col cols="2" lg="1" md="1">
                <v-avatar size="40">
                  <v-icon :color="getColorByRank(email.cmessage.rank)">mdi-alert-circle</v-icon>
                </v-avatar>
              </v-col> -->
              <v-col cols="8">
                <span :style="email.seen ? (isInDarkMode ? 'color: #BDBDBD' : 'color: #424242') : 'font-weight: bold;'"> {{ email.cmessage.type }}</span>
              </v-col>
              <v-col cols="4">
                <span class="subtitle" :style="email.seen ? (isInDarkMode ? 'color: #BDBDBD' : 'color: #424242') : 'font-weight: bold;'">{{ `${new Date(email.dateAdded).toTremolFpString()}` }}</span>
              </v-col>
            </v-row>
            <!-- <template v-slot:actions>
              <v-icon :color="getColorByRank(email.cmessage.rank)"> mdi-alert-circle </v-icon>
            </template> -->
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-divider class="mb-5"></v-divider>
            <template v-if="email.cmessage.text.indexOf(s_Invoice.toLowerCase()) > -1 && getEmailText(email.cmessage.text)[1].length > 0">
              <v-row style="white-space: pre">
                {{ getEmailText(email.cmessage.text)[0] }}
                <span @click="goToPaymentsAndOpenInvoice('Invoice_' + getEmailText(email.cmessage.text)[1] + '.pdf')">
                  <v-icon small>mdi-file-pdf</v-icon>
                  <span style="cursor: pointer; text-decoration: underline">{{ getEmailText(email.cmessage.text)[1] }}</span>
                </span>
                {{ getEmailText(email.cmessage.text)[2] }}
              </v-row>
            </template>
            <template v-else>
              {{ email.cmessage.text }}
            </template>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <v-row class="row-header ma-0 pa-0" :style="'height: ' + legendHeight + 'px;'" justify="end" align="center">
      {{ isOnMobile ? "" : s_Legend + ":" }}
      <v-tabs class="ma-0 pa-0 flex-grow-0" :style="isOnMobile ? '' : 'width: auto;'" show-arrows dense hide-slider background-color="transparent">
        <v-tab class="ma-0 pa-0" v-for="(msg, iindex) in emailTypes" :key="iindex">
          <v-card flat outlined class="ma-1 pa-1" width="100%" height="32px" align="center" justify="center" @click="filterType = msg" :style="`cursor: pointer; margin-bottom: 3px; border-left: 4px solid ${msg.Color}`">
            <v-row class="ma-0 pa-0" justify="space-between" align="center">
              <span>{{ msg.text }}</span>
            </v-row>
          </v-card>
        </v-tab>
      </v-tabs>
    </v-row>
  </div>
</template>

<script>
import DataManager, { MessageTypes, ErrorMessage } from "../../js/DataManager";
import bus, { TR } from "../../main";

export default {
  data() {
    return {
      error_message: null,
      isSaveDisabled: false,
      datatype: null,
      isLoading: true,
      activeEmail: null,
      search: "",
      emails: [],
      filterType: null,
      emailTypes: Object.values(MessageTypes).reverse(),
      legendHeight: 50,
      s_Legend: TR.Legend,
      s_Invoice: TR.Invoice,
      s_NoMessagesFound: TR.NoMessagesFound,
      s_NoMessagesReceived: TR.NoMessagesReceived,
      s_DataProcessingPleaseWait: TR.DataProcessingPleaseWait,
      s_FilterByType: TR.FilterByType,
      s_FilterBySubject: TR.FilterBySubject,
      s_Read: TR.Read,
      s_NotRead: TR.NotRead,
      s_MarkRead: TR.MarkRead,
      s_MarkNotRead: TR.MarkNotRead,
    };
  },
  computed: {
    filterEmails() {
      return this.emails.filter((email) => {
        return (this.filterType == null || email.cmessage.rank == this.filterType.Rank) && email.cmessage.type.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
  methods: {
    goToPaymentsAndOpenInvoice(invoice) {
      if (DataManager.getData(DataManager.DataType.user, true).isDistributor) {
        this.$router.push({ path: "/" + TR.Locale + "/distributorPayments" });
      } else {
        this.$router.push({ path: "/" + TR.Locale + "/balanceLog" });
      }
      this.openInvoice(invoice);
    },
    getEmailText(text) {
      var match = new RegExp("4\\d{9}", "g").exec(text);
      // var match = /@"[4]\d{9}"/.exec(text);
      if (match.index == -1) {
        return [text, "", ""];
      } else {
        return [text.substring(0, match.index), text.substring(match.index, match.index + 10), text.substring(match.index + 10)];
      }
    },
    setTitleAndData(meta, error) {
      this.datatype = meta.datatype;
      this.isLoading = false;
      if (error.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
        this.emails = DataManager.getData(this.datatype).slice();

        bus.$emit(bus.EVENT_DataManager_DATA_CHANGED, DataManager.DataType.messages);
        //console.log(JSON.stringify(this.emails));
      } else {
        this.error_message = error.Message;
        this.dialogLoader.showError(this.error_message, { location: "center" });
      }
    },
    markAsRead(emailIndex) {
      if (emailIndex != undefined) {
        this.emails[emailIndex].seen = true;
        var msg = { id: this.emails[emailIndex].id, seen: true };
        DataManager.markMessages(msg, (error) => {
          if (error.ErrorCode != ErrorMessage.ERROR_CODE_OK) {
            this.dialogLoader.showError(error.Message);
          }
          bus.$emit(bus.EVENT_DataManager_DATA_CHANGED, DataManager.DataType.messages);
          setTimeout(() => {
            this.isSaveDisabled = false;
          }, 3000);
        });
      }
    },
    markAsUnread(emailIndex) {
      if (emailIndex != undefined) {
        this.emails[emailIndex].seen = false;
        var msg = { id: this.emails[emailIndex].id, seen: false };
        DataManager.markMessages(msg, (error) => {
          if (error.ErrorCode != ErrorMessage.ERROR_CODE_OK) {
            this.dialogLoader.showError(error.Message);
          }
          bus.$emit(bus.EVENT_DataManager_DATA_CHANGED, DataManager.DataType.messages);
          setTimeout(() => {
            this.isSaveDisabled = false;
          }, 3000);
        });
      }
    },
    getColorByRank(rank) {
      var found = this.emailTypes.find((e) => e.Rank == rank);
      if (!found) return "";
      return found.Color;
    },
  },
  watch: {
    activeEmail: function () {
      if (this.activeEmail != undefined && this.emails[this.activeEmail].seen == false) {
        this.markAsRead(this.activeEmail);
      }
    },
  },
  mounted() {
    bus.$on(bus.EVENT_DataManager_DATA_CHANGED, (datatype) => {
      if (datatype == this.datatype) {
        var newData = DataManager.getData(this.datatype, true);
        if (this.activeEmail) {
          this.activeEmail += newData.length - this.emails.length;
        }
        this.emails = newData.slice();
      }
    });
    // bus.$on(bus.EVENT_MailBox_ExpandMailById, (id) => {
    //   this.filterType = null;
    //   this.$nextTick(() => {
    //     var emIdx = this.emails.indexOf(this.emails.find((e) => e.id == id));
    //     this.activeEmail = emIdx;
    //     this.$nextTick(() => {
    //       this.markAsRead(emIdx);
    //     });
    //   });
    // });
  },
};
</script>

<style scoped>
</style>